import { ReactNode } from 'react'

import { IconChevronFilledDown } from '@avantstay/backoffice-vectors'

import { ICON_SIZE } from '../constants'
import { useClassNames } from '../utils/useClassNames'

interface DropdownMenuGroupProps {
  folded: boolean
  children: ReactNode
  onClick: () => void
}

export const DropdownMenuGroup = ({ folded, children, onClick }: DropdownMenuGroupProps) => {
  const { merge, prefix, withClassPrefix } = useClassNames('picker-menu-group')

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <div role="group" className={merge({ folded }, withClassPrefix())} onClick={onClick}>
      <div className={prefix('title')} tabIndex={-1}>
        <span>{children}</span>
        <IconChevronFilledDown
          aria-hidden
          className={prefix('caret')}
          width={ICON_SIZE}
          height={ICON_SIZE}
        />
      </div>
    </div>
  )
}
